module.exports = __webpack_public_path__ + "img/tool_icon_2.2673aed.png";